import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ProSidebarProvider } from 'react-pro-sidebar';
import { ToastContainer, Zoom } from 'react-toastify';
import { SkeletonTheme } from 'react-loading-skeleton';
import { BusinessDataUserAPIFile } from './BusinessFlow/BusinessDataUserAPIFile';

if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'production') {
  const observer = new MutationObserver(() => {
    const overlay = document.querySelector('iframe#webpack-dev-server-client-overlay');
    if (overlay) overlay.remove();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

window.addEventListener('unhandledrejection', (event) => {
  event.preventDefault();
});

window.addEventListener('error', (event) => {
  event.preventDefault();
});
class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: false };
  }

  componentDidCatch(error) {
    console.warn('Suppressed render error:', error.message);
  }

  render() {
    return this.props.children;
  }
}
window.onerror = function (message, source, lineno, colno, error) {
  console.warn('Suppressed global error:', message);
  return true; // ← this prevents the red overlay
};

window.onunhandledrejection = function (event) {
  console.warn('Suppressed unhandled rejection:', event.reason);
  event.preventDefault(); // ← this prevents the red overlay
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BusinessDataUserAPIFile>
    <React.StrictMode>

      <ProSidebarProvider>
        <SkeletonTheme duration={3} highlightColor="#3333">
          <GlobalErrorBoundary>
            <App />
          </GlobalErrorBoundary>
        </SkeletonTheme>
        <ToastContainer autoClose={2000} transition={Zoom} closeButton={false} hideProgressBar={true}
          className="foo" style={{ width: "fit-content", minWidth: "200px" }}

        />

      </ProSidebarProvider>
    </React.StrictMode>
  </BusinessDataUserAPIFile>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
